<table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 mt-30">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef>ID</th>
    <td mat-cell *matCellDef="let element"> {{element.id}} </td>
  </ng-container>

  <ng-container matColumnDef="label">
    <th mat-header-cell *matHeaderCellDef>Label</th>
    <td mat-cell *matCellDef="let element"> {{element.label}} </td>
  </ng-container>

  <ng-container matColumnDef="value">
    <th mat-header-cell *matHeaderCellDef>Valeur</th>
    <td mat-cell *matCellDef="let element"> {{element.value}} </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let element">
      <a class="icon" (click)="edit(element)"><img src="/assets/edit.svg"></a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div *ngIf="parameters.length > 0" class="row mt-30" style="justify-content: center;">
  <div [class]="pagination?.prev != null ? 'button-pagination' : 'button-pagination disabled'" (click)="previous()"><span>Précédent</span></div>
  <div class="ml-20" [class]="pagination?.next != null ? 'button-pagination' : 'button-pagination disabled'" (click)="next()"><span>Suivant</span></div>
</div>
